import { Badge } from 'react-bootstrap';

export const Status = ({ status }: { status: string }) => {
  const statusClass =
    {
      COMPLETED: 'bg-success',
      IN_PROGRESS: 'bg-warning',
      REJECTED: 'bg-danger',
      RETRIED: 'bg-info',
    }[status] ?? 'bg-secondary';

  const label =
    {
      COMPLETED: 'Completado',
      IN_PROGRESS: 'En Progreso',
      REJECTED: 'Rechazado',
      RETRIED: 'Reintentado',
    }[status] ?? 'Sin Estado';

  return (
    <Badge className={`fw-bold ${statusClass} text-white`}>
      {label.charAt(0).toUpperCase() + label.slice(1)}
    </Badge>
  );
};
